export const heroData = {
  title: "Pricing & Plans",
  subtitle: "Choose the plan that suits your purpose and budget. Every course promises an experience that simply cannot be found on the ground.",
  image:
    "https://readdy.ai/api/search-image?query=Luxury%20helicopter%20cabin%20interior%20with%20leather%20seats%20and%20panoramic%20window%20showing%20night%20city%20lights%20outside%2C%20warm%20golden%20ambient%20lighting%2C%20dark%20navy%20sky%2C%20premium%20aviation%20experience%2C%20elegant%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=pricehero01&orientation=landscape",
};

export const plansData = {
  label: "PLAN",
  title: "Yokohama Helicopter Cruise — Plan List",
  plans: [
    {
      name: "Night View Short",
      duration: "~15 min",
      route: "Minato Mirai Illumination → Bay Bridge Circuit",
      price: "Please inquire",
      description: "A quick and accessible course to enjoy Yokohama's night view. Perfect for first-timers.",
      features: ["2 guests", "Drink service", "Basic safety briefing"],
      popular: false,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20cabin%20interior%20at%20night%20with%20city%20lights%20visible%20through%20window%2C%20soft%20warm%20interior%20lighting%2C%20leather%20seats%2C%20intimate%20luxury%20atmosphere%2C%20dark%20navy%20sky%2C%20editorial%20aviation%20photography%2C%20no%20text&width=600&height=400&seq=pplan01&orientation=landscape",
    },
    {
      name: "Night View Standard",
      duration: "~25 min",
      route: "Minato Mirai → Bay Bridge → Red Brick Warehouse → Yamashita Park",
      price: "Please inquire",
      description: "The most popular course, covering Yokohama's iconic landmarks at a comfortable pace. Ideal for anniversary dates.",
      features: ["2–3 guests", "Drink service", "Commemorative photo option", "Detailed safety briefing"],
      popular: true,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20aerial%20view%20of%20illuminated%20Yokohama%20Bay%20Bridge%20at%20night%20with%20city%20skyline%2C%20deep%20navy%20sky%2C%20sparkling%20lights%2C%20luxury%20travel%20experience%2C%20editorial%20photography%2C%20no%20text&width=600&height=400&seq=pplan02&orientation=landscape",
    },
    {
      name: "Sunset + Night View",
      duration: "~30 min",
      route: "Magic Hour around sunset → Transition to night view",
      price: "Please inquire",
      description: "Experience the moment the sky shifts from golden sunset to glittering night — the most extraordinary course.",
      features: ["2–3 guests", "Drink service", "Commemorative photo option", "Mt. Fuji view (clear weather)", "Detailed safety briefing"],
      popular: false,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20flying%20over%20coastal%20Japanese%20city%20during%20dramatic%20sunset%2C%20warm%20orange%20sky%20transitioning%20to%20deep%20navy%2C%20bay%20water%20reflecting%20colors%2C%20luxury%20aerial%20experience%2C%20editorial%20photography%2C%20no%20text&width=600&height=400&seq=pplan03&orientation=landscape",
    },
    {
      name: "Premium Night View",
      duration: "~40 min",
      route: "Full Yokohama circuit + extended surrounding area",
      price: "Please inquire",
      description: "A luxurious circuit of the greater Yokohama area. Perfect for a truly special anniversary or surprise.",
      features: ["2–3 guests", "Champagne service", "Commemorative photo included", "Mt. Fuji view (clear weather)", "Detailed safety briefing", "Dedicated attendant"],
      popular: false,
      image:
        "https://readdy.ai/api/search-image?query=Wide%20aerial%20panoramic%20night%20view%20of%20Yokohama%20city%20from%20helicopter%2C%20entire%20bay%20area%20with%20thousands%20of%20sparkling%20lights%2C%20deep%20navy%20sky%2C%20luxury%20premium%20experience%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=600&height=400&seq=pplan04&orientation=landscape",
    },
  ],
};

export const optionsData = {
  label: "OPTION",
  title: "Optional Add-Ons",
  items: [
    {
      name: "Commemorative Photo Pack",
      desc: "A professional photographer will capture photos before and after boarding. Includes digital data delivery.",
      price: "Please inquire",
    },
    {
      name: "Gift Wrapping",
      desc: "Special gift wrapping for gift tickets. Message cards are also available.",
      price: "Please inquire",
    },
    {
      name: "Floral Arrangement",
      desc: "A bouquet prepared inside the cabin — perfect for proposals and anniversary celebrations.",
      price: "Please inquire",
    },
    {
      name: "Transfer Service",
      desc: "A taxi arranged between Yokohama Station area and the helipad.",
      price: "Please inquire",
    },
  ],
};

export const notesData = {
  label: "NOTE",
  title: "Important Notes",
  items: [
    "Prices may vary depending on the season and date. Please contact us for details.",
    "Listed prices include insurance and fuel surcharges.",
    "For groups of 3 or more, pricing may vary by aircraft type. Please consult us in advance.",
    "Flights may be cancelled in rain or strong winds for safety reasons. Please refer to our Cancellation Policy.",
    "Weight restrictions may apply in some cases. Please let us know at the time of booking.",
  ],
};

export const finalCTA = {
  title: "Found a plan that interests you?\nFeel free to reach out.",
  subtitle: "Our dedicated staff will suggest the perfect plan to match your needs",
  ctas: [
    { label: "Inquire About Booking", href: "/contact", type: "primary" },
    { label: "First-Time Visitors", href: "/first-time", type: "ghost" },
  ],
};
